import React, { useContext, useEffect, useState } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import { MdOutlineNoteAlt } from "react-icons/md";
import { Button, IconButton, Tooltip } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid";
import { ConfirmNotification, FilterBar1, TableView1 } from "@/components";
import { useDeleteDeal, useMetersData } from "@/hooks";
import moment from "moment";
import { urlFriendlyString } from "@/utils";

type DataQualityRow = {
  id: string | number;
  ts: string;
  [key: string]: unknown;
};

type DataQualityAction = "note" | "delete";

type FilterValues = {
  building?: { value?: string };
  meter?: { value?: string };
  energyType?: { value?: string };
  date?: { startDate?: Date; endDate?: Date };
  segment?: string;
};

type ConfirmResult = {
  result: string;
  parameters?: {
    ids?: Array<string | number>;
  };
};

// import { Spinner } from "react-bootstrap";
// import {FileUploadDrawer} from "../../features";
// import {CommentsDrawer} from "../../features/dataQuality1/CommentsDrawer";

export const DataQualityConsumption = () => {
  // const { restricted } = props;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  // const navigate = useNavigate();
  const { user } = useUser();
  const { currentTeam: customer, currentSubsidiary: group } = user || {};

  //region React Hooks (useState)
  const [building, setBuilding] = useState("all");
  const [meter, setMeter] = useState("all");
  const [energyType, setEnergyType] = useState("all");
  const [fromDate, setFromDate] = useState<any>();
  const [toDate, setToDate] = useState<any>();
  const [segment, setSegment] = useState("year");
  const [showConfirm, setShowConfirm] = useState(false);
  const [dialogParameters, setDialogParameters] = useState<{
    action?: "delete-single" | "delete-multi";
    ids?: Array<string | number>;
  }>({});
  // const [openUploadSidebar, setOpenUploadSidebar] = useState(false);
  // const [openCommentSidebar, setOpenCommentSidebar] = useState(false);
  const [fileNameForExport, setFileNameForExport] = useState(
    "data-quality-export",
  );

  //endregion  React Hooks (useState)

  useEffect(() => {
    setFileNameForExport(
      urlFriendlyString(
        "data-quality-consumption-" +
          building +
          "-" +
          meter +
          "-" +
          energyType +
          "-" +
          segment +
          "-" +
          fromDate +
          "-" +
          toDate,
      ),
    );
  }, [building, energyType, fromDate, meter, segment, toDate]);

  // const filters = {
  //   customer,
  //   building,
  //   meter,
  //   energyType,
  //   fromDate,
  //   toDate
  // };
  // const { dealsList, loading } = useDealsList(filters);
  const { delete: deleteDeal, deleting } = useDeleteDeal();

  // Temp code
  const { data: rawData, loading } = useMetersData({
    meterType: energyType,
    meteringPointId: meter,
    address: building,
    customer: customer,
    group: group,
    fromDate: fromDate ? fromDate.toString().slice(0, 19) : undefined,
    toDate: toDate ? toDate.toString().slice(0, 19) : undefined,
    resolution: "m",
    fileType: "excel",
  });

  const data = rawData.map((object: { ts: string; [key: string]: unknown }) => {
    return {
      ...object,
      id: object.ts,
    };
  });

  // moment.locale("fr");
  // let m = moment(1316116057189);
  //
  // end tmp code

  // const [disabledDeleteButton, setDisabledDeleteButton] = useState(true);

  // const { dealsList } = useDealsList();
  // const [editableRow, seteditableRow] = useState({});
  // const [edit_show, setedit] = useState(false);
  // const [delete_show, setdelete] = useState(false);
  // const [selectedIds, setSelectedIds] = useState([]);

  // const handleClose_edit = () => setedit(false);

  // const handleShow_edit = () => setedit(true);

  // const handleClose_delete = () => setdelete(false);

  // const handleShow_delete = () => setdelete(true);

  /**
   *
   * @param row
   */
  // function edit_functionality(row) {
  //   // seteditableRow(row);
  //   navigate(`/data/deals/edit/${row.id}`);
  // }

  /**
   *
   * @param row
   */
  function delete_functionality(row: DataQualityRow) {
    setDialogParameters({
      action: "delete-single",
      ids: [row.id],
    });
    setShowConfirm(true);
  }

  // const handleOnRowSelectionModelChange = (ids) => {
  // setSelectedIds(ids);
  // if (ids.length) {
  //   setDisabledDeleteButton(false);
  // } else {
  //   setDisabledDeleteButton(true);
  // }
  // };

  /**
   *
   * @param row
   * @param action
   */
  function performAction(row: DataQualityRow, action: DataQualityAction) {
    switch (action) {
      case "note":
        handleCommentClick();
        break;
      case "delete":
        delete_functionality(row);
        break;
      default:
        break;
    }
  }

  /**
   *
   * @param params
   */
  function columnFormatter(params: GridRenderCellParams<DataQualityRow>) {
    return (
      <div className="w-100 d-flex justify-content-center">
        {/* {!restricted && ( */}
        {/*   <Tooltip title={gettext("Edit")} arrow> */}
        {/*     <IconButton onClick={() => performAction(params.row, "edit")}> */}
        {/*       <FaUserEdit size={16} /> */}
        {/*     </IconButton> */}
        {/*   </Tooltip> */}
        {/* )} */}

        {/* <Tooltip title={gettext("Delete")} arrow> */}
        {/*   <IconButton onClick={() => performAction(params.row, "delete")}> */}
        {/*     <MdDelete size={16} /> */}
        {/*   </IconButton> */}
        {/* </Tooltip> */}

        <Tooltip title={gettext("Notes")} arrow>
          <IconButton onClick={() => performAction(params.row, "note")}>
            <MdOutlineNoteAlt size={16} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }

  const columns = [
    {
      field: "ts",
      headerName: gettext("Date"),
      flex: 1,
      // minWidth: 150,
      headerAlign: "left",
      valueGetter: ({ value }: { value?: string | Date | null }) =>
        value && new Date(value),
      renderCell: (params: GridRenderCellParams<DataQualityRow>) => (
        <strong>
          {segment === "day"
            ? moment(params?.value).format("DD MMM YYYY hh:mm A")
            : segment === "month"
              ? moment(params?.value).format("DD MMM YYYY")
              : moment(params?.value).format("MMM YYYY")}
        </strong>
      ),
      type: "date",
    },
    {
      field: "consumptionDkk",
      headerName: gettext("Fabeke Data"),
      flex: 1,
      // minWidth: 150,
      headerAlign: "left",
      type: "string",
    },
    {
      field: "consumptionUser",
      headerName: gettext("User Data"),
      flex: 1,
      // minWidth: 150,
      headerAlign: "left",
      type: "string",
    },
    {
      field: "consumptionDifference",
      headerName: gettext("Difference"),
      flex: 1,
      // minWidth: 150,
      headerAlign: "left",
      type: "string",
    },
    // {
    //   field: "id",
    //   headerName: gettext("ID"),
    //   checkboxSelection: true
    // },
    // {
    //   field: "customer",
    //   headerName: gettext("Customer"),
    //   flex: 1,
    //   // minWidth: 150,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "building",
    //   headerName: gettext("Building"),
    //   flex: 1,
    //   // minWidth: 150,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "meter",
    //   headerName: gettext("Meter"),
    //   flex: 1,
    //   // minWidth: 150,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "energyType",
    //   headerName: gettext("Energy Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "mainPriceType",
    //   headerName: gettext("Main Price Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "fromDate",
    //   headerName: gettext("From"),
    //   headerAlign: "left",
    //   maxWidth: "100",
    //   type: "date",
    //   valueGetter: ({ value }) => value && new Date(value)
    // },
    // {
    //   field: "toDate",
    //   headerName: gettext("To"),
    //   headerAlign: "left",
    //   maxWidth: "100",
    //   type: "date",
    //   valueGetter: ({ value }) => value && new Date(value)
    // },
    // {
    //   field: "currency",
    //   headerName: gettext("Currency"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "priceType",
    //   headerName: gettext("Price Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "pricePrice",
    //   headerName: gettext("Price Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "priceKwh",
    //   headerName: gettext("Price kWh"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "priceShare",
    //   headerName: gettext("Price Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "systemType",
    //   headerName: gettext("System Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "systemPrice",
    //   headerName: gettext("System Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "systemKwh",
    //   headerName: gettext("System kWh"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "systemShare",
    //   headerName: gettext("System Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "epadType",
    //   headerName: gettext("EPAD Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "epadPrice",
    //   headerName: gettext("EPAD Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "epadKwh",
    //   headerName: gettext("EPAD kWh"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "epadShare",
    //   headerName: gettext("EPAD Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "profileType",
    //   headerName: gettext("Profile Type"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "string"
    // },
    // {
    //   field: "profilePrice",
    //   headerName: gettext("Profile Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "profileKwh",
    //   headerName: gettext("Profile kWh"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "profileShare",
    //   headerName: gettext("Profile Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "markupPrice",
    //   headerName: gettext("Markup Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "markupShare",
    //   headerName: gettext("Markup Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "commissionPrice",
    //   headerName: gettext("Commission Price"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "commissionShare",
    //   headerName: gettext("Commission Share"),
    //   flex: 1,
    //   headerAlign: "left",
    //   type: "number"
    // },
    // {
    //   field: "createdAt",
    //   headerName: gettext("Created At"),
    //   headerAlign: "left",
    //   type: "date",
    //   valueGetter: ({ value }) => value && new Date(value)
    // },
    // {
    //   field: "updatedAt",
    //   headerName: gettext("Updated At"),
    //   headerAlign: "left",
    //   type: "date",
    //   valueGetter: ({ value }) => value && new Date(value)
    // },
    {
      field: "actions",
      headerName: gettext("Actions"),
      hideable: false,
      maxWidth: "100",
      // flex: 1,
      // minWidth: 80,
      // maxWidth: 80,
      // headerAlign: "center",
      // type: "actions",
      renderCell: (params: GridRenderCellParams<DataQualityRow>) =>
        columnFormatter(params),
    },
  ];

  const initialState = {
    pagination: {
      paginationModel: {
        page: 0,
        pageSize: 100,
      },
    },
    // columns: {
    //   columnVisibilityModel: {
    //     id: false,
    //     customer: false,
    //     currency: false,
    //     // mainPriceType: false,
    //     priceType: false,
    //     pricePrice: false,
    //     priceKwh: false,
    //     priceShare: false,
    //     systemType: false,
    //     systemPrice: false,
    //     systemKwh: false,
    //     systemShare: false,
    //     epadType: false,
    //     epadPrice: false,
    //     epadKwh: false,
    //     epadShare: false,
    //     profileType: false,
    //     profileKwh: false,
    //     profilePrice: false,
    //     profileShare: false,
    //     markupPrice: false,
    //     markupShare: false,
    //     commissionPrice: false,
    //     commissionShare: false,
    //     createdAt: false,
    //     updatedAt: false
    //   }
    // }
  };

  const handleGetSelectedValues = (selectedValues: FilterValues) => {
    if (selectedValues?.building?.value) {
      setBuilding(selectedValues.building.value);
    }

    if (selectedValues?.meter?.value) {
      setMeter(selectedValues.meter.value);
    }

    if (selectedValues?.energyType?.value) {
      setEnergyType(selectedValues.energyType.value);
    }

    if (selectedValues?.date?.startDate) {
      setFromDate(selectedValues.date.startDate.toISOString());
    }

    if (selectedValues?.date?.endDate) {
      setToDate(selectedValues.date.endDate.toISOString());
    }

    if (selectedValues?.segment) {
      setSegment(selectedValues.segment);
    }
  };

  const handleOnClickDeleteMultiple = (ids: Array<string | number>) => {
    setDialogParameters({
      action: "delete-multi",
      ids: ids,
    });
    setShowConfirm(true);
  };

  const handleGetResult = (obj: ConfirmResult) => {
    if (obj.result === "yes") {
      deleteDeal({
        ids: (obj?.parameters?.ids || []).map(String),
      });
    }
    setShowConfirm(false);
  };

  const handleUploadClick = () => {
    // setOpenUploadSidebar(true);
  };

  // const handleCloseUpload = () => {
  //   setOpenUploadSidebar(false);
  // };

  const handleCommentClick = () => {
    // setOpenCommentSidebar(true);
  };

  // const handleCloseComments = () => {
  //   setOpenCommentSidebar(false);
  // };

  const preToolbar = () => {
    return (
      <>
        {/* <Button variant="contained" component={Link} to={"/data/deals/add"}> */}
        {/*   {gettext("Add contract")} */}
        {/* </Button> */}
        {/* <Button disabled={disabledDeleteButton} variant="contained" color={"error"}> */}
        {/*   Delete */}
        {/* </Button> */}
      </>
    );
  };

  const postToolbar = () => {
    return (
      <>
        <Button
          variant="contained"
          onClick={handleUploadClick}
          sx={{
            ml: 1,
          }}
        >
          {gettext("Upload Data")}
        </Button>
        {/* <Button disabled={disabledDeleteButton} variant="contained" color={"error"}> */}
        {/*   Delete */}
        {/* </Button> */}
      </>
    );
  };

  const headerRight = () => {
    return (
      <>
        {/* <Button variant="contained" component={Link} to={"/data/deals/add"}> */}
        {/*   {gettext("Add contract")} */}
        {/* </Button> */}
      </>
    );
  };

  return (
    <>
      <TableView1
        title={gettext("Data validation - consumption")}
        rows={data}
        // rows={[]}
        columns={columns}
        loading={loading}
        checkboxSelection={false}
        initialState={initialState}
        preToolbar={preToolbar()}
        postToolbar={postToolbar()}
        headerRight={headerRight()}
        showGridToolbar={true}
        showGridToolbarDeleteButton={false}
        showGridToolbarDensitySelector={false}
        showGridToolbarColumnsButton={false}
        showGridToolbarExport={true}
        showGridToolbarFilterButton={false}
        showGridToolbarQuickFilter={false}
        fileNameForExport={fileNameForExport}
        beforeTable={
          <>
            <FilterBar1
              getSelectedValues={handleGetSelectedValues}
              showBuilding={true}
              showMeter={true}
              showEnergyType={true}
              showDateMultiple={true}
              showBuildingAll={false}
              showMeterAll={true}
              showEnergyTypeAll={false}
            />
            <br />
          </>
        }
        // onRowSelectionModelChange={handleOnRowSelectionModelChange}
        onClickDeleteMultiple={handleOnClickDeleteMultiple}
      />

      {/* <DataGridComponent */}
      {/*   rows={dealsList} */}
      {/*   columns={columns} */}
      {/*   loading={loading} */}
      {/*   disableSelectionOnClick={true} */}
      {/*   initialState={{ pinnedColumns: { right: ["actions"] } }} */}
      {/*   autoHeight */}
      {/*   // getRowId={row => row.Id} */}
      {/* /> */}

      {/* <AddDealForm */}
      {/*   open={edit_show} */}
      {/*   handleClose={handleClose_edit} */}
      {/*   editableRow={editableRow} */}
      {/* /> */}

      {/* <DeleteModel */}
      {/*   show={delete_show} */}
      {/*   onHide={handleClose_delete} */}
      {/*   editableRow={editableRow} */}
      {/*   // getTeamMembers={props.getTeamMembers} */}
      {/* /> */}
      <ConfirmNotification
        isOpen={showConfirm}
        parameters={dialogParameters}
        getResult={handleGetResult}
      />
      {deleting ? (
        <div className="position-absolute bg-dark opacity-50 w-100 h-100 d-flex justify-content-center align-items-center">
          {/*<Spinner animation="border" variant="light"/>*/}
        </div>
      ) : null}
      {/*<FileUploadDrawer*/}
      {/*  isOpen={openUploadSidebar}*/}
      {/*  handleClose={handleCloseUpload}*/}
      {/*/>*/}

      {/*<CommentsDrawer*/}
      {/*  isOpen={openCommentSidebar}*/}
      {/*  handleClose={handleCloseComments}*/}
      {/*/>*/}
    </>
  );
};
